// Trading Statistics - English
export default {
  loading: {
    text: "Loading...",
  },
  common: {
    showOnGraph: "Graph",
    none: "--",
  },
  usdt: {
    name: "USDT",
    first: "First USDT:",
  },
  fields: {
    earliestIn: "Earliest Inflow",
    latestIn: "Latest Inflow",
    earliestOut: "Earliest Outflow",
    latestOut: "Latest Outflow",
    inQty: "Inflow Quantity",
    outQty: "Outflow Quantity",
    inAvgQty: "Avg Inflow Quantity",
    outAvgQty: "Avg Outflow Quantity",
    inCount: "Inflow Tx Count",
    outCount: "Outflow Tx Count",
    inAddressCount: "Inflow Address Count",
    outAddressCount: "Outflow Address Count",
  },
  currency: {
    firstPrefix: "First ",
  },
  bigAddress: {
    empty:
      "Too many transactions for this address; currently unsupported to view.",
  },
};
